import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components 

import Box from '@mui/material/Box';

interface Props { 
    children: any; 
    extraStyle?: any; 
}; 

const Interface: React.FC<Props> = ({ children, extraStyle }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 

    // -- 

    // width: `calc(100vw - ${sidebarMinWidth}px)`, (interface); 

    return (

        <Box 
            component="main"
            maxWidth="xs"
            sx={[{
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center', 
                height: '100vh', 
                width: '100vw',
                left: 0, 
                overflowX: 'hidden',
                overflowY: 'hidden', 
                position: 'absolute',
                color: colors?.text,
                backgroundColor: colors?.interface,
            }, extraStyle]}>

            {children}

        </Box>

  );

};

export default Interface;